export default __webpack_public_path__ + "static/media/HopIn.2d5ed27b.svg";